import React from "react";
import { useSelector } from "react-redux";
import parse from "html-react-parser";
import QualificationJourney from "./QualificationJourney";
import ExperienceJourney from "./ExperienceJourney";
import CreateResumeBox from "./CreateResumeBox";
import Certifications from "./Certifications";

const CandidateOverView = () => {
  const { profile } = useSelector((state) => state.customer);

  const additional_fields = profile?.data ? profile?.data : {};
  console.log(additional_fields, "Additional Fields");

  return (
    <>
      <div>
        <h5 className="fs-18 fw-bold">About</h5>
        <div className="text-muted mt-4">
          {additional_fields?.details
            ? parse(additional_fields.details)
            : "No details available."}
        </div>
      </div>

      {profile?.customerType === 0 && (
        <div className="mt-4 mb-4">
          <CreateResumeBox />
        </div>
      )}

      <div className="candidate-education-details mt-4">
        <h6 className="fs-18 fw-bold mb-0">Qualifications</h6>

        <QualificationJourney />
      </div>

      <div className="candidate-education-details mt-4">
        <h6 className="fs-18 fw-bold mb-0">Experiences</h6>

        <ExperienceJourney />
      </div>

      {/* <div className='candidate-education-details mt-4'>
        <h6 className='fs-18 fw-bold mb-0'>Certifications</h6>

        <Certifications />
      </div> */}
    </>
  );
};

export default CandidateOverView;
